<template>
  <section class="error">
    <p class="error__type">Błąd 404</p>
    <p class="error__result">Strona nie została odnaleziona... </p>
    <div class="error__reason">
      <div class="emoticon red">;(</div>
      <ul class="statement">
        <p class="statement__heading">Wygląda na to że:</p>
        <li class="statement__list">
          adres internetowy został wpisany błędnie
        </li>
        <li class="statement__list"> strona została przeniesiona lub usunięta</li>
      </ul>
    </div>
    <button class="error__button red">
      <a href="/" class="error__button--main">
        Przejdź na stronę główną
        <span class="arrow">
                            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
                                <path fill="#FFF" fill-rule="evenodd"
                                      d="M12.13 6.403a.441.441 0 0 0-.066-.082L6.644.9a.472.472 0 1 0-.667.667l5.178 5.177-5.088 5.087a.472.472 0 1 0 .667.667l5.42-5.42a.47.47 0 0 0-.025-.676z"></path>
                            </svg>
                       </span>
      </a>
    </button>
  </section>
</template>

<script setup>
import {onMounted} from "vue";

onMounted(() => {
  setTimeout(() => {
    window.location = "/"
  }, 3000)
})
</script>

<style scoped lang="scss">
@import "@/assets/scss/views/404.scss";
</style>
